/**
 * class Superscript
 * this class encloses one or more text excerpts in the consigned node with the superscript tags and replaces the original text.
 */
export default class Superscript {

    /**
     * 
     * @param {object} node 
     * @param {string} str
     */
    constructor(node, str) {
        this.node = node;
        this.excerpt = str;
        this.execute();
    }

    /**
     * replacer
     * @param {string} match 
     * @param {int} offset 
     * @param {string} orig 
     */
    static replacer(match, offset, orig) {                 
        return `<sup>${match}</sup>`;
    }

    execute() {
        let regEx = new RegExp(this.excerpt, "g");
        let result = this.node.innerHTML.replace(regEx, Superscript.replacer);

        this.node.innerHTML = result;
    }
}